import { fromJS } from 'immutable';
import { SET_CARDS } from './constants';

export const setCards = (cards) => ({
  type: SET_CARDS,
  payload: fromJS({ cards }),
});
